import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import ConfirmationPopup from "./ConfirmationPopup";

export default function ConfirmSubmitPopup({ open, submitting, filledCount, taxRollYear, onConfirm, onCancel }) {
  return (
    <Dialog
      open={open}
      onClose={submitting ? undefined : onCancel}
      disableEscapeKeyDown
      maxWidth="sm"
      fullWidth
      slotProps={{ paper: { sx: { borderRadius: 3, p: 1 } } }}
    >
      <DialogContent>
        <ConfirmationPopup
          title="Confirm submission"
          checkboxLabel="I have read and agree to the certification statement above."
          confirmLabel="Submit Notification"
          busyLabel="Submitting..."
          busy={submitting}
          confirmColor="success"
          onConfirm={onConfirm}
          onCancel={onCancel}
        >
          By submitting this form, I certify that all information provided herein is accurate and complete to
          the best of my knowledge. I understand that submission of this Preliminary Notification constitutes
          intent to place direct charges on the <strong>{taxRollYear}</strong>{" "}
          property tax roll for San Bernardino County for the <strong>{filledCount}</strong> subagenc
          {filledCount === 1 ? "y" : "ies"} listed in this form.
        </ConfirmationPopup>
      </DialogContent>
    </Dialog>
  );
}
